import React from "react";
import styled from "styled-components";
import Link from "next/link";

const SeoLinksWrapper = styled.section`
  padding: 3rem 1.5rem 1.5rem;
  text-align: center;

  ${({ theme }) => theme.mq.lg`
    padding: 6rem 1.5rem 3rem;
  `}
`;

const Title = styled.h3`
  ${({ theme }) => theme.mq.lg`
    font-size: 2.5rem;
    margin: 0 0 3rem;
  `}
`;

const LinksList = styled.ul`
  display: block;
  margin: 0;
  padding: 0;

  ${({ theme }) => theme.mq.lg`
    display: flex;
    justify-content: center;
    max-width: 60rem;
    margin: 0 auto;
    flex-wrap: wrap;
  `}
`;

const LinksListItem = styled.li`
  list-style-type: none;
  margin: 0;
  padding: 0;

  ${({ theme }) => theme.mq.lg`
    padding: 0 1.5rem;
  `}
`;

const PageName = styled.h4`
  color: ${({ theme }) => theme.themeColors.primary};
  margin: 0 0 0.75rem;
`;

const PagesList = styled.ul`
  display: flex;
  justify-content: center;
  margin: 0 0 2rem;
  padding: 0;

  ${({ theme }) => theme.mq.lg`
    margin: 0 0 3rem;
  `}
`;

const PagesListItem = styled.li`
  color: ${({ theme }) => theme.themeColors.darkGreen4};
  margin: 0 1rem;
  list-style-type: disc;

  :first-of-type {
    list-style-type: none;
  }

  :first-of-type,
  :last-of-type {
    margin: 0;
  }

  ::marker {
    font-size: 0.75rem;
  }

  a {
    color: ${({ theme }) => theme.themeColors.darkGreen4};
    font-weight: 400;

    :hover {
      text-decoration: underline;
    }
  }
`;

const data = [
  {
    pageName: "Austin, TX",
    linkGroomer: "/home/austin/groomers",
    linkTrainer: "/home/austin/trainers",
    linkVet: "/home/austin/vets",
  },
  {
    pageName: "Denver, CO",
    linkGroomer: "/home/denver/groomers",
    linkTrainer: "/home/denver/trainers",
    linkVet: "/home/denver/vets",
  },
  {
    pageName: "New York, NY",
    linkGroomer: "/home/new-york/groomers",
    linkTrainer: "/home/new-york/trainers",
    linkVet: "/home/new-york/vets",
  },
  {
    pageName: "Philadelphia, PA",
    linkGroomer: "/home/philadelphia/groomers",
    linkTrainer: "/home/philadelphia/trainers",
    linkVet: "/home/philadelphia/vets",
  },
  {
    pageName: "San Antonio, TX",
    linkGroomer: "/home/san-antonio/groomers",
    linkTrainer: "/home/san-antonio/trainers",
    linkVet: "/home/san-antonio/vets",
  },
  {
    pageName: "San Francisco, CA",
    linkGroomer: "/home/san-francisco/groomers",
    linkTrainer: "/home/san-francisco/trainers",
    linkVet: "/home/san-francisco/vets",
  },
  {
    pageName: "Washington DC",
    linkGroomer: "/home/dc/groomers",
    linkTrainer: "/home/dc/trainers",
    linkVet: "/home/dc/vets",
  },
];

function SeoLinks() {
  return (
    <SeoLinksWrapper>
      <Title>Find a provider in your area</Title>
      <LinksList>
        {data?.map((item) => {
          const { pageName, linkGroomer, linkTrainer, linkVet } = item;
          return (
            <LinksListItem key={pageName}>
              <PageName>{pageName}</PageName>
              <PagesList>
                <PagesListItem>
                  <Link href={linkGroomer}>Groomers</Link>
                </PagesListItem>
                <PagesListItem>
                  <Link href={linkTrainer}>Trainers</Link>
                </PagesListItem>
                <PagesListItem>
                  <Link href={linkVet}>Vets</Link>
                </PagesListItem>
              </PagesList>
            </LinksListItem>
          );
        })}
      </LinksList>
    </SeoLinksWrapper>
  );
}

export default SeoLinks;
